import { Injectable } from '@angular/core';
import { WsChatService } from '../ws-chat/ws-chat.service';
import { WsPacketService } from '../ws-packet/ws-packet.service';
import { WebSocketPacket } from '../../interfaces/all';
@Injectable({
  providedIn: 'root'
})
export class LdsPrebuiltWschatService {

  constructor(private ws: WsChatService, private wsPacketService: WsPacketService) { }

  updateSettings(settings) {
    let wsPacket = this.wsPacketService.getPacket('user', 'update', {settings: {dashboard: {settings: settings}}});
    this.ws.sendMsg({
      data: wsPacket, next: (res) => {
        console.log('settings updated', res);
      }
    });
  }

  readFeature(featureId): Promise<WebSocketPacket> {
    let wsPacket = this.wsPacketService.getPacket('feature', 'read', {featureId: featureId});
    return this.ws._sendMsg(wsPacket);
  }

}
